import { CreateAcademicPeriodType } from "../../../types/AcademicPeriod";
import { post } from "../../../utils/axios-config";
import { ACADEMIC_PERIODS } from "../../../utils/constants";

export const createAcademicPeriod = async (data: CreateAcademicPeriodType) => await post<CreateAcademicPeriodType, string>(ACADEMIC_PERIODS, data);